import { State } from "../../types";

export type ReOrderBlockAction = Readonly<{
  blockId: string;
  direction: "UP" | "DOWN";
  type: "REORDER BLOCK";
}>;

export const reOrderBlock = (state: State, action: ReOrderBlockAction): State => {
  if (state.readonly) {
    return state;
  }
  if (!(action.blockId in state.blocks)) {
    return state;
  }
  const index = state.blockOrder.indexOf(action.blockId);
  if (index < 0) {
    return state;
  }
  switch (action.direction) {
    case "DOWN":
      if (index >= state.blockOrder.length - 1) {
        return state;
      }
      return {
        ...state,
        blockOrder: [
          ...state.blockOrder.slice(0, index),
          state.blockOrder[index + 1],
          state.blockOrder[index],
          ...state.blockOrder.slice(index + 2),
        ],
      };
    case "UP":
      if (index <= 0) {
        return state;
      }
      return {
        ...state,
        blockOrder: [
          ...state.blockOrder.slice(0, index - 1),
          state.blockOrder[index],
          state.blockOrder[index - 1],
          ...state.blockOrder.slice(index + 1),
        ],
      };
  }
};
